import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param feed Feed
 * @param organisationId string
 * @return {Promise<any>|Promise}
 */
export default (function (feed, organisationId) {
    var url = applyPathVariables(EndPoints.ORGANISATION_FEED, { organisationId: organisationId });
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, data: feed });
    return request.execute();
});
